/* eslint-disable */
define(function (Viewport) {
    /**
    * @title    - Cta Module
    * @desc     - Overall code for Cta module
    * @param    - none
    * @return   - object with public functions and/or variables
    */
    Navigation = (function() {

        // declare private global variables for this module
        var navigationButton    = document.querySelector('.header__hamburger'),
            navigation          = document.querySelector('.navigation--mobile__list'),
            html                = document.querySelector('html'),
            searchForm          = document.querySelector('.header__search'),
            searchButton        = document.querySelector('.header__search-trigger');

        function toggleClass(className, element) {
          if(element.classList.contains(className)) {
            element.classList.remove(className);
          } else {
            element.classList.add(className);
          }
        }

        function removeClass(className) {
          if(document.querySelectorAll('.' + className).length > 0) {
            var activeItems = document.querySelectorAll('.' + className);

            for(var x = 0; x < activeItems.length; x++) {
              activeItems[x].classList.remove(className);
            }
          }
        }

        var init = function() {
          if (!navigationButton) {
            return;
          }

          navigationButton.addEventListener('click', function(e) {
            e.preventDefault();
            toggleClass('navigation--mobile__list--active', navigation);
            toggleClass('body--mobile__list--active', html);
          });

          var parentItems = navigation.querySelectorAll('li.menu-item-has-children a');

          for (var i = 0; i < parentItems.length; i++) {
            parentItems[i].addEventListener('click', function(e) {
              var element   = e.target.closest('a'),
                  parent    = element.parentNode,
                  sub       = parent.querySelector('.sub-menu');

              if (sub !== undefined) {
                if ((
                  (window.innerWidth || document.documentElement.clientWidth) > 767) && 
                  parent.parentNode.classList.contains('navigation__list') && 
                  parent.classList.contains('menu-item-has-children') && 
                  !parent.classList.contains('navigation__item--active')
                ) {
                  removeClass('navigation__sub--active');
                  removeClass('navigation__item--active');
                }

                toggleClass('navigation__sub--active', sub);
                toggleClass('navigation__item--active', parent);
                e.preventDefault();
              }
            });
          }

          searchButton.addEventListener('click', function(e) {
            toggleClass('header__search--active', searchForm);
            e.preventDefault();
          });
        }

        // return public functions and/or variables to use in other modules
        return {
            init: init,
        };


    }());

    Navigation.init();
});


// WEBPACK FOOTER //
// ./scripts/legacy/modules/navigation.js